var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',{class:_vm.classes},[(_vm.displayIcon)?_c('b-icon-at'):_vm._e(),_c('b-link',{attrs:{"href":`mailto:${_vm.value}`,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }